export default __webpack_public_path__ + "static/media/16.09710f03.webp";